
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'underscore';


@Injectable()
export class NavBarService {

    constructor(private http: HttpClient) {

    }
    public search(term: string): Observable<any> {
        return this.http.get<any>('/assets/json/search-results.json').pipe(
            map(ele => _.filter(ele, e => e.name.toString().toLowerCase().includes(term.toLowerCase())
                || e.category.toString().toLowerCase().includes(term.toLowerCase()))));
    }
}

